import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "834593b5-645e-4006-9586-387f5d2aba0e"
// title: "Local Partnership"
// type: :html
// key: "local-partnership-page"
// parent_id: nil
export function LocalPartnershipPage834593b5645e40069586387f5d2aba0e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} LocalPartnershipPage834593b5645e40069586387f5d2aba0e gf-page-layout`}>
      {props["header"] || <ContentItem className="Header45c779a7Aa414c6091aaEb5fa28af523" parentTag={buildClassName("Header45c779a7Aa414c6091aaEb5fa28af523", parentTag)} contentSlug="local-partnership-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      <main>
        {props["page-content"] || <PageContentSimplified className="PageContent5fcba8140fa6473dB7260ad00ef248b2" parentTag={buildClassName("PageContent5fcba8140fa6473dB7260ad00ef248b2", parentTag)} className="main-inner" {...props} />}
      </main>
      {props["footer"] || <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="FooterAcbd53638e7e406e9854Db27794266b8" {...props} />}
    </div>
  );
}

// id: "3bdd316c-f62b-4625-8d01-d7e955aee21c"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d7f67521-28ca-4010-a121-13ca3c6da302"
export function Footer3bdd316cF62b46258d01D7e955aee21c(props: any) {
  return (
    <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer3bdd316cF62b46258d01D7e955aee21c" {...props} />
  );
}

// id: "f08d98ea-b5ef-4c8f-9a67-250b50f25d11"
// title: ""
// type: :html
// key: "main"
// parent_id: "12bd26b2-e7e7-43d3-a6f1-1d0661bd7b1e"
export function MainF08d98eaB5ef4c8f9a67250b50f25d11(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainF08d98eaB5ef4c8f9a67250b50f25d11`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards3ad8f92f549941d7Ae2623c19f2b1d04" parentTag={buildClassName("Cards3ad8f92f549941d7Ae2623c19f2b1d04", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "5d7a3994-7c6a-4b60-b69a-76d7f49b112b"
// title: ""
// type: :text
// key: "subType"
// parent_id: "36dc729e-979b-4b82-b4b5-a075534ff46e"
export const SubType5d7a39947c6a4b60B69a76d7f49b112b = "post";

// id: "2504fb62-59c8-41b6-b44f-2c5b475922c9"
// title: ""
// type: :text
// key: "class"
// parent_id: "5fcba814-0fa6-473d-b726-0ad00ef248b2"
export const Class2504fb6259c841b6B44f2c5b475922c9 = "main-inner";

// id: "5d9c8e6f-1277-4ace-890a-73b4b2797bc0"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "fa476651-9517-4519-8493-43f1b3e31f10"
export function Quote5d9c8e6f12774ace890a73b4b2797bc0(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote5d9c8e6f12774ace890a73b4b2797bc0" parentTag={buildClassName("Quote5d9c8e6f12774ace890a73b4b2797bc0", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "eedb1e11-5f82-436f-b7d2-5aeb50a648d0"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterEedb1e115f82436fB7d25aeb50a648d0(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 footer`}>
      {props["links"] || <Navigation className="Links0d6cd8af4ceb45acB755F1a6272fc021" parentTag={buildClassName("Links0d6cd8af4ceb45acB755F1a6272fc021", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="LogoEed334a6Da5940e6B806C6cfd5bbd3da" parentTag={buildClassName("LogoEed334a6Da5940e6B806C6cfd5bbd3da", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright73d2a67b5973473187b6176e6b57d6fd" parentTag={buildClassName("Copyright73d2a67b5973473187b6176e6b57d6fd", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow64417cd2A88743b5Bec0294b0143a79e" parentTag={buildClassName("Groupflow64417cd2A88743b5Bec0294b0143a79e", parentTag)} {...props} />}
    </footer>
  );
}

// id: "0d6cd8af-4ceb-45ac-b755-f1a6272fc021"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "eedb1e11-5f82-436f-b7d2-5aeb50a648d0"
export function Links0d6cd8af4ceb45acB755F1a6272fc021(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links0d6cd8af4ceb45acB755F1a6272fc021" parentTag={buildClassName("Links0d6cd8af4ceb45acB755F1a6272fc021", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "73d2a67b-5973-4731-87b6-176e6b57d6fd"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "eedb1e11-5f82-436f-b7d2-5aeb50a648d0"
export function Copyright73d2a67b5973473187b6176e6b57d6fd(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright73d2a67b5973473187b6176e6b57d6fd" parentTag={buildClassName("Copyright73d2a67b5973473187b6176e6b57d6fd", parentTag)} {...props} />
  );
}

// id: "f1ebfacd-de23-4fd1-a454-7479ea0a35f9"
// title: ""
// type: :text
// key: "as"
// parent_id: "9827314c-e930-4512-be59-7ebcd8e712e1"
export const AsF1ebfacdDe234fd1A4547479ea0a35f9 = "header";

// id: "2a560823-f9c8-49be-8752-bd4ccb57dd42"
// title: ""
// type: :text
// key: "title"
// parent_id: "e790418a-a828-486b-92aa-2a927f9cbe3f"
export const Title2a560823F9c849be8752Bd4ccb57dd42 = "Secondary Page";

// id: "a5645d7e-15d4-41f7-abb4-513d7604824a"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "06b0c289-f95e-47e4-81d0-0cdc239b9164"
export const ContentSlugA5645d7e15d441f7Abb4513d7604824a = "about-us-header-with-hero";

// id: "85f02606-f631-4f1a-8da7-48c04094bf8a"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTop85f02606F6314f1a8da748c04094bf8a(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTop85f02606F6314f1a8da748c04094bf8a header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo0f254212453d40b782e6301aed443a54" parentTag={buildClassName("LinkedLogo0f254212453d40b782e6301aed443a54", parentTag)} label={<Logo className="LabelC582c958Afdb46b4A93f715b3b65bb70" parentTag={buildClassName("LabelC582c958Afdb46b4A93f715b3b65bb70", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} url="/" className="linked-logo" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="NavigationEdde6d06Efaf478a91d89fa53db41cab" parentTag={buildClassName("NavigationEdde6d06Efaf478a91d89fa53db41cab", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "e6baa8df-d4a6-4a5f-848d-1c856f3acdf9"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "e1ce4a26-a101-45c6-9e87-360c34d03f4c"
export function HeaderE6baa8dfD4a64a5f848d1c856f3acdf9(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderE6baa8dfD4a64a5f848d1c856f3acdf9" parentTag={buildClassName("HeaderE6baa8dfD4a64a5f848d1c856f3acdf9", parentTag)} className="public-header-with-hero home-page" subType="header_with_hero" contentSlug="home-header-with-hero" as="header" {...props} />
  );
}

// id: "6e0bda58-93e1-4a00-bdc0-4fc3372b3be5"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "45c779a7-aa41-4c60-91aa-eb5fa28af523"
export const ContentSlug6e0bda5893e14a00Bdc04fc3372b3be5 = "local-partnership-header-with-hero";

// id: "6ae39a16-edec-4f79-97b1-47bd3a47bb4e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e790418a-a828-486b-92aa-2a927f9cbe3f"
export const ContentSlug6ae39a16Edec4f7997b147bd3a47bb4e = "join-us-header-with-hero";

// id: "6c4e0d24-b2ca-4f0a-8dfd-9dd16ba14c40"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "841c6c9f-9ff5-4f16-824a-7e48d2926c7f"
export const ContentSlug6c4e0d24B2ca4f0a8dfd9dd16ba14c40 = "public-events-header-with-hero";

// id: "2cfaf39d-021c-4756-a02f-2103f1c0338c"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage2cfaf39d021c4756A02f2103f1c0338c(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage2cfaf39d021c4756A02f2103f1c0338c`} classname="gf-page-layout">
      {props["header"] || <ContentItem className="HeaderE790418aA828486b92aa2a927f9cbe3f" parentTag={buildClassName("HeaderE790418aA828486b92aa2a927f9cbe3f", parentTag)} title="Secondary Page" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer357e6bd0B11b4be284291d1e4260733a" {...props} />}
    </div>
  );
}

// id: "acbd5363-8e7e-406e-9854-db27794266b8"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "834593b5-645e-4006-9586-387f5d2aba0e"
export function FooterAcbd53638e7e406e9854Db27794266b8(props: any) {
  return (
    <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="FooterAcbd53638e7e406e9854Db27794266b8" {...props} />
  );
}

// id: "955519b9-3121-4853-ae00-f87d05506ec7"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "6b8a032f-72b0-4707-b528-97cd51577a49"
export function HeaderTop955519b931214853Ae00F87d05506ec7(props: any) {
  return (
    <DefaultHeaderTop85f02606F6314f1a8da748c04094bf8a parentTag="HeaderTop955519b931214853Ae00F87d05506ec7" {...props} />
  );
}

// id: "ee361f8c-431f-4c40-af66-814c66f71de6"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "6172b48b-c883-4c86-9672-bb3259f95222"
export function HeaderTopEe361f8c431f4c40Af66814c66f71de6(props: any) {
  return (
    <DefaultHeaderTop85f02606F6314f1a8da748c04094bf8a parentTag="HeaderTopEe361f8c431f4c40Af66814c66f71de6" {...props} />
  );
}

// id: "e7b4180c-c8a2-4846-8fb0-0a5aa15fe806"
// title: ""
// type: :text
// key: "as"
// parent_id: "963c20dd-7157-4fc0-9df4-151a3567337e"
export const AsE7b4180cC8a248468fb00a5aa15fe806 = "header";

// id: "6a980afb-bf60-4bb5-ac6a-ae9b48e92135"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "b3d47050-959c-43e7-a869-4d3e798bad2e"
export const ContentSlug6a980afbBf604bb5Ac6aAe9b48e92135 = "public-faq-main-content";

// id: "6b8a032f-72b0-4707-b528-97cd51577a49"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader6b8a032f72b04707B52897cd51577a49(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader6b8a032f72b04707B52897cd51577a49 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop85f02606F6314f1a8da748c04094bf8a parentTag="HeaderTop955519b931214853Ae00F87d05506ec7" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero1aae8dab7a374d5bA61e95c17249843d parentTag="Hero23a1e71207564e8898940885c1155b66" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "0f254212-453d-40b7-82e6-301aed443a54"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "85f02606-f631-4f1a-8da7-48c04094bf8a"
export function LinkedLogo0f254212453d40b782e6301aed443a54(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo0f254212453d40b782e6301aed443a54" parentTag={buildClassName("LinkedLogo0f254212453d40b782e6301aed443a54", parentTag)} label={<Logo className="LabelC582c958Afdb46b4A93f715b3b65bb70" parentTag={buildClassName("LabelC582c958Afdb46b4A93f715b3b65bb70", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} url="/" className="linked-logo" {...props} />
  );
}

// id: "f0dcafd1-ea23-49fa-8bee-2b7a81eacba3"
// title: ""
// type: :reference
// key: "header"
// parent_id: "68b863e0-ef19-409c-bdbf-d049601391c7"
export function HeaderF0dcafd1Ea2349fa8bee2b7a81eacba3(props: any) {
  return (
    <SecondaryMarketingHeader6b8a032f72b04707B52897cd51577a49 parentTag="HeaderF0dcafd1Ea2349fa8bee2b7a81eacba3" title="Join Us" {...props} />
  );
}

// id: "7fc0b611-0da6-404b-a378-23da94e305f8"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "eed334a6-da59-40e6-b806-c6cfd5bbd3da"
export const ContentSlug7fc0b6110da6404bA37823da94e305f8 = "footer-logo";

// id: "e8ca7f01-7bb4-4f2a-8eac-4c5ba98617d3"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "9827314c-e930-4512-be59-7ebcd8e712e1"
export const ContentSlugE8ca7f017bb44f2a8eac4c5ba98617d3 = "public-contact-header-with-hero";

// id: "e5363b2b-556b-4412-b7e5-e05a39c69432"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "6172b48b-c883-4c86-9672-bb3259f95222"
export function HeroWrapperE5363b2b556b4412B7e5E05a39c69432(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapperE5363b2b556b4412B7e5E05a39c69432`}>
      {props["hero"] || <Hero className="Hero47d1126818d147719f5f62941aa2a2b0" parentTag={buildClassName("Hero47d1126818d147719f5f62941aa2a2b0", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "1aae8dab-7a37-4d5b-a61e-95c17249843d"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero1aae8dab7a374d5bA61e95c17249843d(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero1aae8dab7a374d5bA61e95c17249843d hero`}>
      <h1 className="title">
        {props["title"] || TitleCf22495cE7514233Ba7b657dfd64a5d9}
      </h1>
    </div>
  );
}

// id: "e790418a-a828-486b-92aa-2a927f9cbe3f"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "2cfaf39d-021c-4756-a02f-2103f1c0338c"
export function HeaderE790418aA828486b92aa2a927f9cbe3f(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="HeaderE790418aA828486b92aa2a927f9cbe3f" parentTag={buildClassName("HeaderE790418aA828486b92aa2a927f9cbe3f", parentTag)} title="Secondary Page" contentSlug="join-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "70eef6e6-1a5a-4f3d-b404-22e5e1fa1bba"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "e1ce4a26-a101-45c6-9e87-360c34d03f4c"
export function Quote70eef6e61a5a4f3dB40422e5e1fa1bba(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="Quote70eef6e61a5a4f3dB40422e5e1fa1bba" parentTag={buildClassName("Quote70eef6e61a5a4f3dB40422e5e1fa1bba", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "6b23b59e-66a4-426f-ab7f-6843eabd4f35"
// title: ""
// type: :text
// key: "className"
// parent_id: "e6baa8df-d4a6-4a5f-848d-1c856f3acdf9"
export const ClassName6b23b59e66a4426fAb7f6843eabd4f35 = "public-header-with-hero home-page";

// id: "9d551037-1a63-4309-91e2-402a0836d0c6"
// title: ""
// type: :text
// key: "className"
// parent_id: "b3d47050-959c-43e7-a869-4d3e798bad2e"
export const ClassName9d5510371a63430991e2402a0836d0c6 = "main-content";

// id: "73178e16-7169-47cd-8238-1199fff89ae2"
// title: ""
// type: :text
// key: "title"
// parent_id: "f0dcafd1-ea23-49fa-8bee-2b7a81eacba3"
export const Title73178e16716947cd82381199fff89ae2 = "Join Us";

// id: "12bd26b2-e7e7-43d3-a6f1-1d0661bd7b1e"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage12bd26b2E7e743d3A6f11d0661bd7b1e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage12bd26b2E7e743d3A6f11d0661bd7b1e gf-page-layout`}>
      {props["header"] || <ContentItem className="Header06b0c289F95e47e481d00cdc239b9164" parentTag={buildClassName("Header06b0c289F95e47e481d00cdc239b9164", parentTag)} contentSlug="about-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      {props["main"] || <MainF08d98eaB5ef4c8f9a67250b50f25d11 />}
      {props["footer"] || <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer742b9290188642d3977aCbb60d7a01b2" {...props} />}
    </div>
  );
}

// id: "963c20dd-7157-4fc0-9df4-151a3567337e"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "d4c27301-72d0-4144-a4d9-33d4523cc5d8"
export function Header963c20dd71574fc09df4151a3567337e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header963c20dd71574fc09df4151a3567337e" parentTag={buildClassName("Header963c20dd71574fc09df4151a3567337e", parentTag)} as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" contentSlug="join-us-header-with-hero" {...props} />
  );
}

// id: "10cf887c-6ae7-4975-a385-71d1001d0bc5"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "e56e468c-71e9-4573-9051-9c528382b472"
export function Footer10cf887c6ae74975A38571d1001d0bc5(props: any) {
  return (
    <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer10cf887c6ae74975A38571d1001d0bc5" {...props} />
  );
}

// id: "7c754a3f-6328-4fe2-8abb-a6d2c049143a"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "36dc729e-979b-4b82-b4b5-a075534ff46e"
export const ContentSlug7c754a3f63284fe28abbA6d2c049143a = "public-contact-main-content";

// id: "c582c958-afdb-46b4-a93f-715b3b65bb70"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "0f254212-453d-40b7-82e6-301aed443a54"
export function LabelC582c958Afdb46b4A93f715b3b65bb70(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LabelC582c958Afdb46b4A93f715b3b65bb70" parentTag={buildClassName("LabelC582c958Afdb46b4A93f715b3b65bb70", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "56450209-315d-4f42-bbfa-f4b3a4cdd98f"
// title: ""
// type: :text
// key: "subType"
// parent_id: "e6baa8df-d4a6-4a5f-848d-1c856f3acdf9"
export const SubType56450209315d4f42BbfaF4b3a4cdd98f = "header_with_hero";

// id: "d7f67521-28ca-4010-a121-13ca3c6da302"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageD7f6752128ca4010A12113ca3c6da302(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageD7f6752128ca4010A12113ca3c6da302`}>
      {props["header"] || <ContentItem className="Header841c6c9f9ff54f16824a7e48d2926c7f" parentTag={buildClassName("Header841c6c9f9ff54f16824a7e48d2926c7f", parentTag)} contentSlug="public-events-header-with-hero" title="Public Events" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer3bdd316cF62b46258d01D7e955aee21c" {...props} />}
    </div>
  );
}

// id: "45c779a7-aa41-4c60-91aa-eb5fa28af523"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "834593b5-645e-4006-9586-387f5d2aba0e"
export function Header45c779a7Aa414c6091aaEb5fa28af523(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header45c779a7Aa414c6091aaEb5fa28af523" parentTag={buildClassName("Header45c779a7Aa414c6091aaEb5fa28af523", parentTag)} contentSlug="local-partnership-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "eed334a6-da59-40e6-b806-c6cfd5bbd3da"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "eedb1e11-5f82-436f-b7d2-5aeb50a648d0"
export function LogoEed334a6Da5940e6B806C6cfd5bbd3da(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoEed334a6Da5940e6B806C6cfd5bbd3da" parentTag={buildClassName("LogoEed334a6Da5940e6B806C6cfd5bbd3da", parentTag)} contentSlug="footer-logo" logoType="FOOTER" {...props} />
  );
}

// id: "85f667cb-7ee0-4cb7-930b-4f86a8515af1"
// title: ""
// type: :text
// key: "subType"
// parent_id: "39041dff-5eae-41d8-a2d1-282e3288890a"
export const SubType85f667cb7ee04cb7930b4f86a8515af1 = "header_with_hero";

// id: "ad25cf2d-076e-4861-811d-31ee82eaf843"
// title: ""
// type: :text
// key: "title"
// parent_id: "841c6c9f-9ff5-4f16-824a-7e48d2926c7f"
export const TitleAd25cf2d076e4861811d31ee82eaf843 = "Public Events";

// id: "ff292193-741e-41ec-8158-5d1eb2ed8c22"
// title: ""
// type: :text
// key: "as"
// parent_id: "06b0c289-f95e-47e4-81d0-0cdc239b9164"
export const AsFf292193741e41ec81585d1eb2ed8c22 = "header";

// id: "d4c27301-72d0-4144-a4d9-33d4523cc5d8"
// title: "Join Us Page"
// type: :html
// key: "join-us-page"
// parent_id: nil
export function JoinUsPageD4c2730172d04144A4d933d4523cc5d8(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} JoinUsPageD4c2730172d04144A4d933d4523cc5d8`}>
      {props["header"] || <ContentItem className="Header963c20dd71574fc09df4151a3567337e" parentTag={buildClassName("Header963c20dd71574fc09df4151a3567337e", parentTag)} as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" contentSlug="join-us-header-with-hero" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer42d070db768844b0BfedC0ae08f721e4" {...props} />}
    </div>
  );
}

// id: "cf22495c-e751-4233-ba7b-657dfd64a5d9"
// title: ""
// type: :text
// key: "title"
// parent_id: "1aae8dab-7a37-4d5b-a61e-95c17249843d"
export const TitleCf22495cE7514233Ba7b657dfd64a5d9 = "Default Title";

// id: "edde6d06-efaf-478a-91d8-9fa53db41cab"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "85f02606-f631-4f1a-8da7-48c04094bf8a"
export function NavigationEdde6d06Efaf478a91d89fa53db41cab(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationEdde6d06Efaf478a91d89fa53db41cab" parentTag={buildClassName("NavigationEdde6d06Efaf478a91d89fa53db41cab", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "da3f4cad-fb7b-4a12-a73f-7fed9d6e862a"
// title: ""
// type: :text
// key: "as"
// parent_id: "45c779a7-aa41-4c60-91aa-eb5fa28af523"
export const AsDa3f4cadFb7b4a12A73f7fed9d6e862a = "header";

// id: "83fc751c-bef6-4ef5-ba32-47eb5d104e3f"
// title: ""
// type: :text
// key: "as"
// parent_id: "e790418a-a828-486b-92aa-2a927f9cbe3f"
export const As83fc751cBef64ef5Ba3247eb5d104e3f = "header";

// id: "9ce9fcf8-41c4-4050-ac75-e3a76432e2e4"
// title: ""
// type: :text
// key: "as"
// parent_id: "841c6c9f-9ff5-4f16-824a-7e48d2926c7f"
export const As9ce9fcf841c44050Ac75E3a76432e2e4 = "header";

// id: "68b863e0-ef19-409c-bdbf-d049601391c7"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages68b863e0Ef19409cBdbfD049601391c7(props: any) {
  return (
    <SecondaryPage2cfaf39d021c4756A02f2103f1c0338c parentTag="ApplicationPages68b863e0Ef19409cBdbfD049601391c7" header={<SecondaryMarketingHeader6b8a032f72b04707B52897cd51577a49 parentTag="HeaderF0dcafd1Ea2349fa8bee2b7a81eacba3" title="Join Us" />} {...props} />
  );
}

// id: "742b9290-1886-42d3-977a-cbb60d7a01b2"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "12bd26b2-e7e7-43d3-a6f1-1d0661bd7b1e"
export function Footer742b9290188642d3977aCbb60d7a01b2(props: any) {
  return (
    <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer742b9290188642d3977aCbb60d7a01b2" {...props} />
  );
}

// id: "8436c32b-1e19-4e55-89ef-18dd7344cf63"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "e1ce4a26-a101-45c6-9e87-360c34d03f4c"
export function Footer8436c32b1e194e5589ef18dd7344cf63(props: any) {
  return (
    <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer8436c32b1e194e5589ef18dd7344cf63" {...props} />
  );
}

// id: "4abe6733-37a8-45f5-bfb1-60cb7e496032"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "a35f63b8-8bd4-47a4-86f6-ab4a02ce7e31"
export const LogoType4abe673337a845f5Bfb160cb7e496032 = "DEFAULT";

// id: "6d6856d5-cde0-4533-81e0-6a39f538b3e8"
// title: ""
// type: :text
// key: "className"
// parent_id: "963c20dd-7157-4fc0-9df4-151a3567337e"
export const ClassName6d6856d5Cde0453381e06a39f538b3e8 = "public-header-with-hero secondary-page";

// id: "bbba02c7-b0b7-4cef-a016-521bfce23a3d"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "1f8fd972-8f9b-4c73-9857-2b7fd7800559"
export const PostSlugBbba02c7B0b74cefA016521bfce23a3d = "home-page-cards";

// id: "7ba043e3-517c-475f-930d-e261b126e2d6"
// title: "Contact Us"
// type: :html
// key: "public-contact-page"
// parent_id: nil
export function PublicContactPage7ba043e3517c475f930dE261b126e2d6(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicContactPage7ba043e3517c475f930dE261b126e2d6 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header9827314cE9304512Be597ebcd8e712e1" parentTag={buildClassName("Header9827314cE9304512Be597ebcd8e712e1", parentTag)} as="header" contentSlug="public-contact-header-with-hero" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />}
      <main>
        {props["content"] || <ContentItem className="Content36dc729e979b4b82B4b5A075534ff46e" parentTag={buildClassName("Content36dc729e979b4b82B4b5A075534ff46e", parentTag)} subType="post" contentSlug="public-contact-main-content" className="main-content" {...props} />}
      </main>
      {props["footer"] || <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer8a586583D57c402c9dd9633e0121331d" {...props} />}
    </div>
  );
}

// id: "06b0c289-f95e-47e4-81d0-0cdc239b9164"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "12bd26b2-e7e7-43d3-a6f1-1d0661bd7b1e"
export function Header06b0c289F95e47e481d00cdc239b9164(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header06b0c289F95e47e481d00cdc239b9164" parentTag={buildClassName("Header06b0c289F95e47e481d00cdc239b9164", parentTag)} contentSlug="about-us-header-with-hero" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "39041dff-5eae-41d8-a2d1-282e3288890a"
// title: "Contact Header Clone CEM6GZI2IPRP07Y1J"
// type: :gf_preset
// key: "header"
// parent_id: "e56e468c-71e9-4573-9051-9c528382b472"
export function Header39041dff5eae41d8A2d1282e3288890a(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header39041dff5eae41d8A2d1282e3288890a" parentTag={buildClassName("Header39041dff5eae41d8A2d1282e3288890a", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="public-faq-header-with-hero" as="header" {...props} />
  );
}

// id: "88d3fc28-d240-4453-9f04-d01f0c7dd576"
// title: ""
// type: :text
// key: "title"
// parent_id: "23a1e712-0756-4e88-9894-0885c1155b66"
export const Title88d3fc28D24044539f04D01f0c7dd576 = "Secondary Marketing Title 2";

// id: "df5f06ce-e4e9-4f65-a0aa-bcd1171ee8f5"
// title: ""
// type: :text
// key: "className"
// parent_id: "9827314c-e930-4512-be59-7ebcd8e712e1"
export const ClassNameDf5f06ceE4e94f65A0aaBcd1171ee8f5 = "public-header-with-hero secondary-page";

// id: "47d11268-18d1-4771-9f5f-62941aa2a2b0"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "e5363b2b-556b-4412-b7e5-e05a39c69432"
export function Hero47d1126818d147719f5f62941aa2a2b0(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero47d1126818d147719f5f62941aa2a2b0" parentTag={buildClassName("Hero47d1126818d147719f5f62941aa2a2b0", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "e56e468c-71e9-4573-9051-9c528382b472"
// title: "FAQ - Frequently Asked Questions"
// type: :html
// key: "public-faq-page"
// parent_id: nil
export function PublicFaqPageE56e468c71e9457390519c528382b472(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicFaqPageE56e468c71e9457390519c528382b472 gf-page-layout`}>
      {props["header"] || <ContentItem className="Header39041dff5eae41d8A2d1282e3288890a" parentTag={buildClassName("Header39041dff5eae41d8A2d1282e3288890a", parentTag)} subType="header_with_hero" className="public-header-with-hero secondary-page" contentSlug="public-faq-header-with-hero" as="header" {...props} />}
      <main>
        {props["content"] || <ContentItem className="ContentB3d47050959c43e7A8694d3e798bad2e" parentTag={buildClassName("ContentB3d47050959c43e7A8694d3e798bad2e", parentTag)} contentSlug="public-faq-main-content" className="main-content" subType="post" {...props} />}
      </main>
      {props["footer"] || <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer10cf887c6ae74975A38571d1001d0bc5" {...props} />}
    </div>
  );
}

// id: "5fcba814-0fa6-473d-b726-0ad00ef248b2"
// title: "Local Partnership - Page Content"
// type: :gf_preset
// key: "page-content"
// parent_id: "834593b5-645e-4006-9586-387f5d2aba0e"
export function PageContent5fcba8140fa6473dB7260ad00ef248b2(props: any) {
  const PageContentSimplified = AppStore.presets["PageContentSimplified"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageContentSimplified className="PageContent5fcba8140fa6473dB7260ad00ef248b2" parentTag={buildClassName("PageContent5fcba8140fa6473dB7260ad00ef248b2", parentTag)} className="main-inner" {...props} />
  );
}

// id: "3ad8f92f-5499-41d7-ae26-23c19f2b1d04"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "f08d98ea-b5ef-4c8f-9a67-250b50f25d11"
export function Cards3ad8f92f549941d7Ae2623c19f2b1d04(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards3ad8f92f549941d7Ae2623c19f2b1d04" parentTag={buildClassName("Cards3ad8f92f549941d7Ae2623c19f2b1d04", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "290bde73-b903-4164-9f1b-a3e940399109"
// title: ""
// type: :text
// key: "subType"
// parent_id: "963c20dd-7157-4fc0-9df4-151a3567337e"
export const SubType290bde73B90341649f1bA3e940399109 = "header_with_hero";

// id: "0a8f414e-5554-40f1-be7a-a8ede29845ac"
// title: ""
// type: :text
// key: "className"
// parent_id: "39041dff-5eae-41d8-a2d1-282e3288890a"
export const ClassName0a8f414e555440f1Be7aA8ede29845ac = "public-header-with-hero secondary-page";

// id: "b9c523de-4524-4c9a-944e-651824ceda8c"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "c582c958-afdb-46b4-a93f-715b3b65bb70"
export const LogoTypeB9c523de45244c9a944e651824ceda8c = "DEFAULT";

// id: "e1ce4a26-a101-45c6-9e87-360c34d03f4c"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePageE1ce4a26A10145c69e87360c34d03f4c(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const PageQuote = AppStore.presets["PageQuote"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageE1ce4a26A10145c69e87360c34d03f4c gf-page-layout`}>
      {props["header"] || <ContentItem className="HeaderE6baa8dfD4a64a5f848d1c856f3acdf9" parentTag={buildClassName("HeaderE6baa8dfD4a64a5f848d1c856f3acdf9", parentTag)} className="public-header-with-hero home-page" subType="header_with_hero" contentSlug="home-header-with-hero" as="header" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack5d3c0e78147d491f8ae74f1c242bb733" parentTag={buildClassName("WelcomeBack5d3c0e78147d491f8ae74f1c242bb733", parentTag)} {...props} />}
      {props["main"] || <MainFa47665195174519849343f1b3e31f10 />}
      {props["footer"] || <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer8436c32b1e194e5589ef18dd7344cf63" {...props} />}
    </div>
  );
}

// id: "fa476651-9517-4519-8493-43f1b3e31f10"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "e1ce4a26-a101-45c6-9e87-360c34d03f4c"
export function MainFa47665195174519849343f1b3e31f10(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} MainFa47665195174519849343f1b3e31f10`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards1f8fd9728f9b4c7398572b7fd7800559" parentTag={buildClassName("Cards1f8fd9728f9b4c7398572b7fd7800559", parentTag)} postSlug="home-page-cards" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />}
      </div>
      {props["quote"] || <PageQuote className="Quote5d9c8e6f12774ace890a73b4b2797bc0" parentTag={buildClassName("Quote5d9c8e6f12774ace890a73b4b2797bc0", parentTag)} contentSlug="home-page-quote" {...props} />}
    </main>
  );
}

// id: "64dbffe3-2876-497a-9c1b-1d4c2656eb49"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "0d6cd8af-4ceb-45ac-b755-f1a6272fc021"
export const NavMenuSlug64dbffe32876497a9c1b1d4c2656eb49 = "footer-nav";

// id: "70c63d41-b2fa-40a8-aae8-7f743db60641"
// title: ""
// type: :text
// key: "className"
// parent_id: "36dc729e-979b-4b82-b4b5-a075534ff46e"
export const ClassName70c63d41B2fa40a8Aae87f743db60641 = "main-content";

// id: "1504bc12-2e66-4572-8cb6-18c16cfad85d"
// title: ""
// type: :text
// key: "class"
// parent_id: "edde6d06-efaf-478a-91d8-9fa53db41cab"
export const Class1504bc122e6645728cb618c16cfad85d = "navigation";

// id: "9db21e22-cb0c-4a67-8e63-c04403d90ca6"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "3ad8f92f-5499-41d7-ae26-23c19f2b1d04"
export const PostSlug9db21e22Cb0c4a678e63C04403d90ca6 = "about-us-cards";

// id: "23a1e712-0756-4e88-9894-0885c1155b66"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "6b8a032f-72b0-4707-b528-97cd51577a49"
export function Hero23a1e71207564e8898940885c1155b66(props: any) {
  return (
    <SecondaryMarketingHero1aae8dab7a374d5bA61e95c17249843d parentTag="Hero23a1e71207564e8898940885c1155b66" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "676f7bd5-539f-4d69-b927-a9d2887c294d"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e6baa8df-d4a6-4a5f-848d-1c856f3acdf9"
export const ContentSlug676f7bd5539f4d69B927A9d2887c294d = "home-header-with-hero";

// id: "28e97c29-fefb-4afb-b4c2-bd0b9999cb5a"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "39041dff-5eae-41d8-a2d1-282e3288890a"
export const ContentSlug28e97c29Fefb4afbB4c2Bd0b9999cb5a = "public-faq-header-with-hero";

// id: "2933e4a3-cd11-4494-a23b-35e12d8c6ca4"
// title: ""
// type: :text
// key: "url"
// parent_id: "0f254212-453d-40b7-82e6-301aed443a54"
export const Url2933e4a3Cd114494A23b35e12d8c6ca4 = "/";

// id: "6f89ee14-2458-45b6-8542-b3824c5ef5cb"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "c582c958-afdb-46b4-a93f-715b3b65bb70"
export const ContentSlug6f89ee14245845b68542B3824c5ef5cb = "header-logo";

// id: "841c6c9f-9ff5-4f16-824a-7e48d2926c7f"
// title: ""
// type: :gf_preset
// key: "header"
// parent_id: "d7f67521-28ca-4010-a121-13ca3c6da302"
export function Header841c6c9f9ff54f16824a7e48d2926c7f(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header841c6c9f9ff54f16824a7e48d2926c7f" parentTag={buildClassName("Header841c6c9f9ff54f16824a7e48d2926c7f", parentTag)} contentSlug="public-events-header-with-hero" title="Public Events" as="header" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "42d070db-7688-44b0-bfed-c0ae08f721e4"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d4c27301-72d0-4144-a4d9-33d4523cc5d8"
export function Footer42d070db768844b0BfedC0ae08f721e4(props: any) {
  return (
    <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer42d070db768844b0BfedC0ae08f721e4" {...props} />
  );
}

// id: "b83a5fc5-5450-4eed-ab02-a721675e6ba6"
// title: ""
// type: :text
// key: "className"
// parent_id: "06b0c289-f95e-47e4-81d0-0cdc239b9164"
export const ClassNameB83a5fc554504eedAb02A721675e6ba6 = "public-header-with-hero secondary-page";

// id: "d4b78a39-2bf0-4ecf-a122-184f3afbd80a"
// title: ""
// type: :text
// key: "className"
// parent_id: "45c779a7-aa41-4c60-91aa-eb5fa28af523"
export const ClassNameD4b78a392bf04ecfA122184f3afbd80a = "public-header-with-hero secondary-page";

// id: "7d4fbbbf-e8e2-4aa9-9a3f-ee96cd2fdbdf"
// title: ""
// type: :text
// key: "className"
// parent_id: "e790418a-a828-486b-92aa-2a927f9cbe3f"
export const ClassName7d4fbbbfE8e24aa99a3fEe96cd2fdbdf = "public-header-with-hero secondary-page";

// id: "8ccc5d7a-9776-45f2-abfc-067baba1ef92"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "5d9c8e6f-1277-4ace-890a-73b4b2797bc0"
export const ContentSlug8ccc5d7a977645f2Abfc067baba1ef92 = "home-page-quote";

// id: "8a586583-d57c-402c-9dd9-633e0121331d"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "7ba043e3-517c-475f-930d-e261b126e2d6"
export function Footer8a586583D57c402c9dd9633e0121331d(props: any) {
  return (
    <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer8a586583D57c402c9dd9633e0121331d" {...props} />
  );
}

// id: "64417cd2-a887-43b5-bec0-294b0143a79e"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "eedb1e11-5f82-436f-b7d2-5aeb50a648d0"
export function Groupflow64417cd2A88743b5Bec0294b0143a79e(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow64417cd2A88743b5Bec0294b0143a79e" parentTag={buildClassName("Groupflow64417cd2A88743b5Bec0294b0143a79e", parentTag)} {...props} />
  );
}

// id: "c30c9331-2da4-46f2-b564-e74b9aa91169"
// title: ""
// type: :text
// key: "className"
// parent_id: "841c6c9f-9ff5-4f16-824a-7e48d2926c7f"
export const ClassNameC30c93312da446f2B564E74b9aa91169 = "public-header-with-hero secondary-page";

// id: "e64eb966-e9cb-4dff-b048-e220690f025b"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "edde6d06-efaf-478a-91d8-9fa53db41cab"
export const NavMenuSlugE64eb966E9cb4dffB048E220690f025b = "marketing-primary-nav";

// id: "001952be-4887-42c6-9a52-ffc09737a2a4"
// title: ""
// type: :text
// key: "subType"
// parent_id: "06b0c289-f95e-47e4-81d0-0cdc239b9164"
export const SubType001952be488742c69a52Ffc09737a2a4 = "header_with_hero";

// id: "18cf1e00-40b1-4673-8c3e-3e3af20af42c"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "1f8fd972-8f9b-4c73-9857-2b7fd7800559"
export const ButtonClass18cf1e0040b146738c3e3e3af20af42c = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "b3d47050-959c-43e7-a869-4d3e798bad2e"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "e56e468c-71e9-4573-9051-9c528382b472"
export function ContentB3d47050959c43e7A8694d3e798bad2e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="ContentB3d47050959c43e7A8694d3e798bad2e" parentTag={buildClassName("ContentB3d47050959c43e7A8694d3e798bad2e", parentTag)} contentSlug="public-faq-main-content" className="main-content" subType="post" {...props} />
  );
}

// id: "5d3c0e78-147d-491f-8ae7-4f1c242bb733"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "e1ce4a26-a101-45c6-9e87-360c34d03f4c"
export function WelcomeBack5d3c0e78147d491f8ae74f1c242bb733(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack5d3c0e78147d491f8ae74f1c242bb733" parentTag={buildClassName("WelcomeBack5d3c0e78147d491f8ae74f1c242bb733", parentTag)} {...props} />
  );
}

// id: "dee03c5e-df19-4049-9879-c59670f81fa6"
// title: ""
// type: :text
// key: "subType"
// parent_id: "45c779a7-aa41-4c60-91aa-eb5fa28af523"
export const SubTypeDee03c5eDf1940499879C59670f81fa6 = "header_with_hero";

// id: "b8d470fe-d549-496b-9db5-ad674871fc47"
// title: ""
// type: :text
// key: "subType"
// parent_id: "e790418a-a828-486b-92aa-2a927f9cbe3f"
export const SubTypeB8d470feD549496b9db5Ad674871fc47 = "header_with_hero";

// id: "0ed007c4-bb6e-4842-a3b9-d771bda9c1ba"
// title: ""
// type: :text
// key: "subType"
// parent_id: "841c6c9f-9ff5-4f16-824a-7e48d2926c7f"
export const SubType0ed007c4Bb6e4842A3b9D771bda9c1ba = "header_with_hero";

// id: "c6bfdf5d-ee2f-4262-a61a-ce9775052917"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "47d11268-18d1-4771-9f5f-62941aa2a2b0"
export const PostSlugC6bfdf5dEe2f4262A61aCe9775052917 = "home-hero";

// id: "6172b48b-c883-4c86-9672-bb3259f95222"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "e1ce4a26-a101-45c6-9e87-360c34d03f4c"
export function HeaderWrapper6172b48bC8834c869672Bb3259f95222(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapper6172b48bC8834c869672Bb3259f95222`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTop85f02606F6314f1a8da748c04094bf8a parentTag="HeaderTopEe361f8c431f4c40Af66814c66f71de6" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapperE5363b2b556b4412B7e5E05a39c69432 />}
    </div>
  );
}

// id: "357e6bd0-b11b-4be2-8429-1d1e4260733a"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "2cfaf39d-021c-4756-a02f-2103f1c0338c"
export function Footer357e6bd0B11b4be284291d1e4260733a(props: any) {
  return (
    <DefaultFooterEedb1e115f82436fB7d25aeb50a648d0 parentTag="Footer357e6bd0B11b4be284291d1e4260733a" {...props} />
  );
}

// id: "b6129575-1946-4764-94ce-93127ac11333"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "70eef6e6-1a5a-4f3d-b404-22e5e1fa1bba"
export const ContentSlugB61295751946476494ce93127ac11333 = "home-page-quote";

// id: "076e4522-64ce-484d-a815-7f505ac46f1e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "963c20dd-7157-4fc0-9df4-151a3567337e"
export const ContentSlug076e452264ce484dA8157f505ac46f1e = "join-us-header-with-hero";

// id: "3455b07b-50be-4b2c-a8aa-38e3ad38096f"
// title: ""
// type: :text
// key: "subType"
// parent_id: "b3d47050-959c-43e7-a869-4d3e798bad2e"
export const SubType3455b07b50be4b2cA8aa38e3ad38096f = "post";

// id: "cd4767a4-83a0-49bb-a00f-054b1a45521b"
// title: ""
// type: :text
// key: "title"
// parent_id: "6b8a032f-72b0-4707-b528-97cd51577a49"
export const TitleCd4767a483a049bbA00f054b1a45521b = "Secondary Marketing Title 1";

// id: "36dc729e-979b-4b82-b4b5-a075534ff46e"
// title: ""
// type: :gf_preset
// key: "content"
// parent_id: "7ba043e3-517c-475f-930d-e261b126e2d6"
export function Content36dc729e979b4b82B4b5A075534ff46e(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Content36dc729e979b4b82B4b5A075534ff46e" parentTag={buildClassName("Content36dc729e979b4b82B4b5A075534ff46e", parentTag)} subType="post" contentSlug="public-contact-main-content" className="main-content" {...props} />
  );
}

// id: "a5696607-33cb-464b-a134-53cbfcc429ec"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "eed334a6-da59-40e6-b806-c6cfd5bbd3da"
export const LogoTypeA569660733cb464bA13453cbfcc429ec = "FOOTER";

// id: "24680b83-37f2-4cfd-9064-b7667143c586"
// title: ""
// type: :text
// key: "subType"
// parent_id: "9827314c-e930-4512-be59-7ebcd8e712e1"
export const SubType24680b8337f24cfd9064B7667143c586 = "header_with_hero";

// id: "3e6e002c-9042-48d4-b366-75cef424ca3c"
// title: ""
// type: :text
// key: "class"
// parent_id: "0f254212-453d-40b7-82e6-301aed443a54"
export const Class3e6e002c904248d4B36675cef424ca3c = "linked-logo";

// id: "9827314c-e930-4512-be59-7ebcd8e712e1"
// title: "Contact Header"
// type: :gf_preset
// key: "header"
// parent_id: "7ba043e3-517c-475f-930d-e261b126e2d6"
export function Header9827314cE9304512Be597ebcd8e712e1(props: any) {
  const ContentItem = AppStore.presets["ContentItem"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentItem className="Header9827314cE9304512Be597ebcd8e712e1" parentTag={buildClassName("Header9827314cE9304512Be597ebcd8e712e1", parentTag)} as="header" contentSlug="public-contact-header-with-hero" className="public-header-with-hero secondary-page" subType="header_with_hero" {...props} />
  );
}

// id: "a35f63b8-8bd4-47a4-86f6-ab4a02ce7e31"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "85f02606-f631-4f1a-8da7-48c04094bf8a"
export function LogoA35f63b88bd447a486f6Ab4a02ce7e31(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoA35f63b88bd447a486f6Ab4a02ce7e31" parentTag={buildClassName("LogoA35f63b88bd447a486f6Ab4a02ce7e31", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "fa3f1224-ae87-494e-99e2-e61dac25eef9"
// title: ""
// type: :text
// key: "as"
// parent_id: "e6baa8df-d4a6-4a5f-848d-1c856f3acdf9"
export const AsFa3f1224Ae87494e99e2E61dac25eef9 = "header";

// id: "4805d8a4-96fa-4568-b010-80e01ab965e2"
// title: ""
// type: :text
// key: "as"
// parent_id: "39041dff-5eae-41d8-a2d1-282e3288890a"
export const As4805d8a496fa4568B01080e01ab965e2 = "header";

// id: "1f8fd972-8f9b-4c73-9857-2b7fd7800559"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "fa476651-9517-4519-8493-43f1b3e31f10"
export function Cards1f8fd9728f9b4c7398572b7fd7800559(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards1f8fd9728f9b4c7398572b7fd7800559" parentTag={buildClassName("Cards1f8fd9728f9b4c7398572b7fd7800559", parentTag)} postSlug="home-page-cards" buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

const Components = {
  LocalPartnershipPage834593b5645e40069586387f5d2aba0e,
  Footer3bdd316cF62b46258d01D7e955aee21c,
  MainF08d98eaB5ef4c8f9a67250b50f25d11,
  SubType5d7a39947c6a4b60B69a76d7f49b112b,
  Class2504fb6259c841b6B44f2c5b475922c9,
  Quote5d9c8e6f12774ace890a73b4b2797bc0,
  DefaultFooterEedb1e115f82436fB7d25aeb50a648d0,
  Links0d6cd8af4ceb45acB755F1a6272fc021,
  Copyright73d2a67b5973473187b6176e6b57d6fd,
  AsF1ebfacdDe234fd1A4547479ea0a35f9,
  Title2a560823F9c849be8752Bd4ccb57dd42,
  ContentSlugA5645d7e15d441f7Abb4513d7604824a,
  DefaultHeaderTop85f02606F6314f1a8da748c04094bf8a,
  HeaderE6baa8dfD4a64a5f848d1c856f3acdf9,
  ContentSlug6e0bda5893e14a00Bdc04fc3372b3be5,
  ContentSlug6ae39a16Edec4f7997b147bd3a47bb4e,
  ContentSlug6c4e0d24B2ca4f0a8dfd9dd16ba14c40,
  SecondaryPage2cfaf39d021c4756A02f2103f1c0338c,
  FooterAcbd53638e7e406e9854Db27794266b8,
  HeaderTop955519b931214853Ae00F87d05506ec7,
  HeaderTopEe361f8c431f4c40Af66814c66f71de6,
  AsE7b4180cC8a248468fb00a5aa15fe806,
  ContentSlug6a980afbBf604bb5Ac6aAe9b48e92135,
  SecondaryMarketingHeader6b8a032f72b04707B52897cd51577a49,
  LinkedLogo0f254212453d40b782e6301aed443a54,
  HeaderF0dcafd1Ea2349fa8bee2b7a81eacba3,
  ContentSlug7fc0b6110da6404bA37823da94e305f8,
  ContentSlugE8ca7f017bb44f2a8eac4c5ba98617d3,
  HeroWrapperE5363b2b556b4412B7e5E05a39c69432,
  SecondaryMarketingHero1aae8dab7a374d5bA61e95c17249843d,
  HeaderE790418aA828486b92aa2a927f9cbe3f,
  Quote70eef6e61a5a4f3dB40422e5e1fa1bba,
  ClassName6b23b59e66a4426fAb7f6843eabd4f35,
  ClassName9d5510371a63430991e2402a0836d0c6,
  Title73178e16716947cd82381199fff89ae2,
  AboutUsPage12bd26b2E7e743d3A6f11d0661bd7b1e,
  Header963c20dd71574fc09df4151a3567337e,
  Footer10cf887c6ae74975A38571d1001d0bc5,
  ContentSlug7c754a3f63284fe28abbA6d2c049143a,
  LabelC582c958Afdb46b4A93f715b3b65bb70,
  SubType56450209315d4f42BbfaF4b3a4cdd98f,
  PublicEventsPageD7f6752128ca4010A12113ca3c6da302,
  Header45c779a7Aa414c6091aaEb5fa28af523,
  LogoEed334a6Da5940e6B806C6cfd5bbd3da,
  SubType85f667cb7ee04cb7930b4f86a8515af1,
  TitleAd25cf2d076e4861811d31ee82eaf843,
  AsFf292193741e41ec81585d1eb2ed8c22,
  JoinUsPageD4c2730172d04144A4d933d4523cc5d8,
  TitleCf22495cE7514233Ba7b657dfd64a5d9,
  NavigationEdde6d06Efaf478a91d89fa53db41cab,
  AsDa3f4cadFb7b4a12A73f7fed9d6e862a,
  As83fc751cBef64ef5Ba3247eb5d104e3f,
  As9ce9fcf841c44050Ac75E3a76432e2e4,
  ApplicationPages68b863e0Ef19409cBdbfD049601391c7,
  Footer742b9290188642d3977aCbb60d7a01b2,
  Footer8436c32b1e194e5589ef18dd7344cf63,
  LogoType4abe673337a845f5Bfb160cb7e496032,
  ClassName6d6856d5Cde0453381e06a39f538b3e8,
  PostSlugBbba02c7B0b74cefA016521bfce23a3d,
  PublicContactPage7ba043e3517c475f930dE261b126e2d6,
  Header06b0c289F95e47e481d00cdc239b9164,
  Header39041dff5eae41d8A2d1282e3288890a,
  Title88d3fc28D24044539f04D01f0c7dd576,
  ClassNameDf5f06ceE4e94f65A0aaBcd1171ee8f5,
  Hero47d1126818d147719f5f62941aa2a2b0,
  PublicFaqPageE56e468c71e9457390519c528382b472,
  PageContent5fcba8140fa6473dB7260ad00ef248b2,
  Cards3ad8f92f549941d7Ae2623c19f2b1d04,
  SubType290bde73B90341649f1bA3e940399109,
  ClassName0a8f414e555440f1Be7aA8ede29845ac,
  LogoTypeB9c523de45244c9a944e651824ceda8c,
  HomePageE1ce4a26A10145c69e87360c34d03f4c,
  MainFa47665195174519849343f1b3e31f10,
  NavMenuSlug64dbffe32876497a9c1b1d4c2656eb49,
  ClassName70c63d41B2fa40a8Aae87f743db60641,
  Class1504bc122e6645728cb618c16cfad85d,
  PostSlug9db21e22Cb0c4a678e63C04403d90ca6,
  Hero23a1e71207564e8898940885c1155b66,
  ContentSlug676f7bd5539f4d69B927A9d2887c294d,
  ContentSlug28e97c29Fefb4afbB4c2Bd0b9999cb5a,
  Url2933e4a3Cd114494A23b35e12d8c6ca4,
  ContentSlug6f89ee14245845b68542B3824c5ef5cb,
  Header841c6c9f9ff54f16824a7e48d2926c7f,
  Footer42d070db768844b0BfedC0ae08f721e4,
  ClassNameB83a5fc554504eedAb02A721675e6ba6,
  ClassNameD4b78a392bf04ecfA122184f3afbd80a,
  ClassName7d4fbbbfE8e24aa99a3fEe96cd2fdbdf,
  ContentSlug8ccc5d7a977645f2Abfc067baba1ef92,
  Footer8a586583D57c402c9dd9633e0121331d,
  Groupflow64417cd2A88743b5Bec0294b0143a79e,
  ClassNameC30c93312da446f2B564E74b9aa91169,
  NavMenuSlugE64eb966E9cb4dffB048E220690f025b,
  SubType001952be488742c69a52Ffc09737a2a4,
  ButtonClass18cf1e0040b146738c3e3e3af20af42c,
  ContentB3d47050959c43e7A8694d3e798bad2e,
  WelcomeBack5d3c0e78147d491f8ae74f1c242bb733,
  SubTypeDee03c5eDf1940499879C59670f81fa6,
  SubTypeB8d470feD549496b9db5Ad674871fc47,
  SubType0ed007c4Bb6e4842A3b9D771bda9c1ba,
  PostSlugC6bfdf5dEe2f4262A61aCe9775052917,
  HeaderWrapper6172b48bC8834c869672Bb3259f95222,
  Footer357e6bd0B11b4be284291d1e4260733a,
  ContentSlugB61295751946476494ce93127ac11333,
  ContentSlug076e452264ce484dA8157f505ac46f1e,
  SubType3455b07b50be4b2cA8aa38e3ad38096f,
  TitleCd4767a483a049bbA00f054b1a45521b,
  Content36dc729e979b4b82B4b5A075534ff46e,
  LogoTypeA569660733cb464bA13453cbfcc429ec,
  SubType24680b8337f24cfd9064B7667143c586,
  Class3e6e002c904248d4B36675cef424ca3c,
  Header9827314cE9304512Be597ebcd8e712e1,
  LogoA35f63b88bd447a486f6Ab4a02ce7e31,
  AsFa3f1224Ae87494e99e2E61dac25eef9,
  As4805d8a496fa4568B01080e01ab965e2,
  Cards1f8fd9728f9b4c7398572b7fd7800559
}

export default Components;